import { z } from "zod";
import { LOCALE_CODES } from "../locales/index.js";

export const localeSchema = z.enum(LOCALE_CODES as [string, ...string[]]);

export const baseSchema = z.object({
  locale: localeSchema.default("de"),
});

export type BaseProps = z.infer<typeof baseSchema>;

export const FPS = 30;

export function secondsToFrames(seconds: number, fps: number = FPS): number {
  return Math.round(seconds * fps);
}
